import React from "react";
import { Link } from "react-router-dom";
import { palette, fonts, socialLinks } from "../pages/theme";
import goldFrame from "../assets/sidebar-mandala.png";

export default function Sidebar({ hours }) {
  // Detect mobile vs desktop once at render
  const isDesktop = typeof window !== "undefined" && window.innerWidth >= 768;

  return (
    <aside
      className="
        flex flex-col justify-between 
        border-r px-6 py-8 relative overflow-hidden
      "
      style={{
        borderColor: palette.railLine,

        // 🚨 KEY FIX:
        // Desktop → show goldFrame
        // Mobile → remove goldFrame and use clean background
        backgroundImage: isDesktop ? `url(${goldFrame})` : "none",
        backgroundSize: isDesktop ? "cover" : "none",
        backgroundRepeat: isDesktop ? "no-repeat" : "none",
        backgroundPosition: isDesktop ? "center top" : "initial",
        backgroundColor: palette.bg,
      }}
    >
      {/* ===== SIDEBAR CONTENT ===== */}
      <div className="relative z-10 bg-[#fff8f0e0] rounded-2xl px-4 py-4">
        
        <Link
          to="/"
          className="block text-xl text-center font-extrabold uppercase tracking-wide"
          style={{ fontFamily: fonts.heading, color: palette.sub }}
        >
          Authentic South Indian Veg
        </Link>

        <p className="mt-2 text-center text-xs" style={{ color: palette.sub }}>
          Dosa • Idli • Uttapam • Thali • Filter Coffee
        </p>

        <p className="mt-10 text-center text-xs" style={{ color: palette.sub }}>
          100% vegetarian kitchen
        </p>

        {/* HOURS */}
        <div className="mt-12 text-sm" style={{ color: palette.sub }}>
          <div
            className="font-semibold text-center text-xl mb-5"
            style={{ fontFamily: fonts.heading }}
          >
            HOURS OF OPERATION
          </div>

          <div className="font-semibold text-center mb-2">Weekday</div>
          <div className="text-center mb-2">{hours.weekday}</div>
          <div className="font-semibold text-center mb-2">Weekend Breakfast</div>
          <div className="text-center mb-2">{hours.weekend_breakfast}</div>
          <div className="font-semibold text-center mb-2">Weekend</div>
          <div className="text-center mb-2">{hours.weekend_timing}</div>
        </div>

        {/* LOCATION */}
        <section className="pt-8 mt-8 border-t" style={{ borderColor: palette.railLine }}>
          <h4
            className="uppercase font-semibold text-center text-xl mb-2"
            style={{ fontFamily: fonts.heading, color: palette.sub }}
          >
            Location
          </h4>

          <p className="mt-3 text-xs" style={{ color: palette.sub }}>
            2481 Taunton Rd #121, Oakville, ON L6H 3R7
          </p>

          {/* MAP */}
          <div
            className="mt-4 rounded-xl overflow-hidden border"
            style={{ borderColor: palette.railLine }}
          >
            <iframe
              title="Carnatic Cafe — Map"
              width="100%"
              height="200"
              style={{ border: 0, display: "block" }}
              loading="lazy"
              allowFullScreen
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2904.0!2d-79.72057!3d43.48578!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b3a994afdcd05%3A0x0!2s2481%20Taunton%20Rd%20%23121%2C%20Oakville%2C%20ON%20L6H%203R7!5e0!3m2!1sen!2sca!4v1700000000000"
            ></iframe>
          </div>

          {/* CONTACT */}
          <div className="mt-6 text-sm space-y-2">
            <div className="font-semibold">Quick Contact</div>

            <a
              href="tel:+13657261646"
              className="inline-flex items-center gap-2 hover:underline"
              style={{ color: palette.sub }}
            >
              📞 +1 (365) 726-1646
            </a>

            <a
              href="mailto:contactus@carnaticcafe.ca"
              className="inline-flex items-center gap-2 hover:underline"
              style={{ color: palette.sub }}
            >
              📧 contactus@carnaticcafe.ca
            </a>
          </div>

          {/* SOCIAL ICONS */}
          <div className="mt-10 flex items-center justify-center gap-10">
            {socialLinks.map((s) => (
              <a key={s.id} href={s.url} target="_blank" rel="noopener noreferrer">
                <img src={s.icon} alt={s.label} style={{ width: 20, height: 20 }} />
              </a>
            ))}
          </div>
        </section>

      </div>
    </aside>
  );
}
